module.exports = __webpack_public_path__ + "static/media/img-integration-02_eng.bfadf9f5.svg";